<template>
  <div class="md-layout">
    <div
      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
    >
      <md-card>
        <md-card-content>
          <b-container fluid>
            <penalties_and_bonus-form :modelvue="penalties_and_bonus" :errors="errors"></penalties_and_bonus-form>
            <md-card-content>
              <div class="tugmalarx">
                <div>
                  <b-button
                    @click="updatePenalties_and_bonus()"
                    class="mr-2 calendar"
                    variant="success"
                  >
                    <b-icon icon="calendar2-plus"></b-icon> {{ $t("Сақлаш") }}
                  </b-button>
                  <b-button
                    @click="cancel()"
                    class="calendar1"
                    variant="danger"
                  >
                    <b-icon icon="calendar2-x"></b-icon> {{ $t("Бекор қилиш") }}
                  </b-button>
                </div>
              </div>
            </md-card-content>
          </b-container>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Penalties_and_bonusForm from "./Form.vue";
import { required, minLength } from "vuelidate/lib/validators";
export default {
  name: "Penalties_and_bonusUpdate",
  components: {
    Penalties_and_bonusForm
  },
  data() {
    return {
      penalties_and_bonus: {
        id: 0,
        cause: "",
        summa: 0,
        min_time: 0,
        max_time: 0,
        type: 'penalty',
        is_early_leave: false
      },
      errors: null
    };
  },
  validations: {
    penalties_and_bonus: {
      cause: {
        required,
        minLength: minLength(4)
      },
      min_time: {
        required
      },
      max_time: {
        required
      }
    }
  },
  methods: {
    updatePenalties_and_bonus() {
      let self = this;
      this.$v.$touch();
      if (this.$v.$invalid == false) {
        axios({
          method: "patch",
          url: `/penalties_and_bonus/update/` + self.$route.params.id,
          data: self.penalties_and_bonus
        }).then(data => {
          if (data) {
            self.$router.push("/penalties_and_bonus");
          }
        });
      } else {
        self.errors = self.$v.penalties_and_bonus;
      }
    },

    getPenalties_and_bonus() {
      let self = this;
      axios({
        method: "get",
        url: `/penalties_and_bonus/one/` + this.$route.params.id
      }).then(res => {
        const d = res.data.data;
        Object.assign(self.penalties_and_bonus, d);
        if (d.is_early_leave === undefined || d.is_early_leave === null) {
          self.$set(self.penalties_and_bonus, 'is_early_leave', false);
        }
      });
    },
    cancel() {
      this.penalties_and_bonus = {
        cause: "",
        summa: 0,
        min_time: 0,
        max_time: 0,
        type: 'penalty'
      };
    }
  },
  mounted() {
    this.getPenalties_and_bonus();
  }
};
</script>
<style>
.tugmalarx {
  display: flex;
  justify-content: right;
  margin-right: 10px;
  margin-bottom: 10px;
}
.calendar {
  box-shadow: 5px 8px 10px rgba(25, 176, 48, 0.5);
}
.calendar1 {
  box-shadow: 5px 8px 10px rgba(176, 25, 25, 0.5);
}
</style>
